module.exports = __webpack_public_path__ + "VIPG6.png?2184a0d6bd3c2ecbd74a946586f79089";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG6.png
// module id = 78
// module chunks = 0